<template>
  <Modal
    @close="$emit('close')"
    :classes="'col-md-4'"
    :title="'Cambiar Correo'"
  >
    <div slot="body" class="body">
      <div class="row">
        <div class="col">
          <CustomInput :icon="'fa fa-at'">
            <input
              v-model="newMail"
              type="text"
              slot="input"
              placeholder="Escriba correo electrónico"
            />
          </CustomInput>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <button class="button logo" @click="changeEmail">
            Cambiar Correo
          </button>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapState } from "vuex";
import CustomInput from "@/components/CustomInput";
import Modal from "@/components/Modal";

export default {
  name: "ChangeEmailModal",
  components: {
    Modal,
    CustomInput,
  },
  computed: {
    ...mapState(["teacherData", "dataUrl"]),
  },
  data() {
    return {
      newMail: null,
    };
  },
  methods: {
    async changeEmail() {
      if (!this.newMail) {
        this.$notify({
          title: ["Debe colocar nuevo correo"],
          type: "danger",
        });
        return;
      }

      if (!/.{1,}@.{1,}[^.]{1,}/.test(this.newMail)) {
        this.$notify({
          title: ["Formato incorrecto"],
          type: "danger",
        });
        return;
      }

      let apiUrl = `${this.dataUrl}/userProfile/updateUserEmail?userId=${this.teacherData.id}&email=${this.newMail}`;
      let loader = this.$loading.show();

      try {
        let { data } = await this.axios.put(apiUrl);

        if (data.status.name.toLocaleLowerCase() == "ok") {
          this.$notify({
            title: ["Cambio exitoso"],
            type: "success",
          });
          this.$emit("close", this.newMail);
        } else {
          this.$notify({
            title: ["Ocurrió un error", data.content],
            type: "danger",
          });
        }
      } catch {
        this.$notify({
          title: ["Ocurrió un error"],
          type: "danger",
        });
      } finally {
        loader.hide();
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
